export const environment = {
  production: true,
  connection: {
    name: 'LH Landring Softline',
    host: 'https://softline-pwa.landring.at/',
    port: 443,
    // host: 'http://devsrv01',
    // port: 8118,
    basePath: '/api'
  },
  theme: '',
  androidUpdateRepository: ''
};
